import { render } from "./Counter.vue?vue&type=template&id=113b21da&scoped=true"
import script from "./Counter.vue?vue&type=script&lang=js"
export * from "./Counter.vue?vue&type=script&lang=js"

import "./Counter.vue?vue&type=style&index=0&id=113b21da&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-113b21da"

export default script